import React from 'react';
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import Select from '../../../form/component/Select'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import LabelInput from '../../../form/component/LabelInput'
import Input from '../../../form/component/Input'
import Checkbox from '../../../form/component/Checkbox'
import currentUserHasAccess from '../../../../util/widget-helper'
import { DELIVERY_TRACKING_WIDGET } from '../../../process/ui-definition/process-ui'
import {
    SHIPMENT_PROVIDER_LIST,
    SHIPMENT_PROVIDER_URL_CONTEXT_KEY,
    DEFAULT_SHIPMENT_PROVIDER,
    TRACKING_URL_CONTEXT_KEY, TRACKING_NUMBER_CONTEXT_KEY, SHIPMENT_PROVIDER_CONTEXT_KEY
} from '../../../logistic/util/ShipmentProviderUtil'

const DeliveryTrackingNumber = ({
        showAlignerNumberCounted,
        context,
        changeProcessContext,
        saveProcessContext,
        validationMessageList,
        getProviderUrl
    }) => {

    if (!currentUserHasAccess(DELIVERY_TRACKING_WIDGET)) {
        return null
    }

    const onShipmentProviderChange = async (key, shipmentProvider) => {
        await setShipmentProvider(shipmentProvider)
        setTrackingUrl()
        saveProcessContext()
    }

    const onTrackingNumberChange = async () => {
        if(!context.shipmentProviderUrl){
            await setShipmentProvider(DEFAULT_SHIPMENT_PROVIDER)
        }
        setTrackingUrl()
        saveProcessContext()
    }

    const setShipmentProvider = async (shipmentProvider) => {
        changeProcessContext(SHIPMENT_PROVIDER_CONTEXT_KEY, shipmentProvider)
        const provider = SHIPMENT_PROVIDER_LIST.find(el => el.id === shipmentProvider)
        const providerUrl = await getProviderUrl(provider.key)
        changeProcessContext(SHIPMENT_PROVIDER_URL_CONTEXT_KEY, providerUrl)
        context.shipmentProviderUrl = providerUrl
    }

    const setTrackingUrl = () => {
        const trackingUrl = context.shipmentProviderUrl.replace('%tracking_number%',context.trackingNumber)
        changeProcessContext(TRACKING_URL_CONTEXT_KEY, trackingUrl)
        saveProcessContext()
    }

    return (
        <ContentBox title="Shipping Tracking Number">
            <Row>
                <Column size={12}>
                    <ValidationMessageList validationMessageList={validationMessageList}/>
                </Column>
            </Row>
            <Row top="M">
                <Column size={4}>
                    <LabelInput label="Tracking Number">
                        <Input
                            name={TRACKING_NUMBER_CONTEXT_KEY}
                            object={context}
                            onChange={changeProcessContext}
                            onBlur={onTrackingNumberChange}
                        />
                    </LabelInput>
                </Column>
                <Column size={4}>
                    <LabelInput label="Shipment Provider">
                        <Select
                            name={SHIPMENT_PROVIDER_CONTEXT_KEY}
                            object={context}
                            defaultValue={DEFAULT_SHIPMENT_PROVIDER}
                            valueList={SHIPMENT_PROVIDER_LIST}
                            onChange={onShipmentProviderChange}
                        />
                    </LabelInput>
                </Column>
                {showAlignerNumberCounted && (<Column size={4}>
                    <br/>
                    <Checkbox
                        onChange={(name, value) => {
                            changeProcessContext(name, value)
                            saveProcessContext()
                        }}
                        object={context}
                        name="alignerNumberCounted">
                        Aligner counted
                    </Checkbox>
                </Column>)}
            </Row>
        </ContentBox>
    )
}

DeliveryTrackingNumber.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    context: PropTypes.object.isRequired,
    changeProcessContext: PropTypes.func.isRequired,
    saveProcessContext: PropTypes.func.isRequired,
    validationMessageList: PropTypes.array.isRequired,
}

export default DeliveryTrackingNumber



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/DeliveryTrackingNumberWidget.js